import { ITatInitialState } from "../../../types/master/tatInterface";
import { TatActionTypes, TatActions } from "../../actionTypes/master/tatActionTypes";


const initialState: ITatInitialState = {
  tatList: [],
  tatData: {
    id: 0,
    origin: "",
    destination: "",
    rate: 0,
    createdAt: "",
    updatedAt: "",
  },
  tatListPageCount: 0,
};

export default function tatReducer(state = initialState, action: TatActionTypes): ITatInitialState {
  switch (action.type) {
    case TatActions.SET_TAT_LIST:
      return {
        ...state,
        tatList: action.payload,
      };

    case TatActions.SET_TAT_LIST_PAGE_COUNT:
      return {
        ...state,
        tatListPageCount: action.payload
      };

    case TatActions.SET_TAT_DATA_BY_ID:
      return {
        ...state,
        tatData: action.payload,
      };

    default:
      return state;
  }
}
